export default {
  verboseName: "Categoria di persona",
  verboseNamePlural: "Categorie di persona",
  modelName: "PersonCategory",
  modelNamePlural: "PersonCategories",
  appName: "people",
  propName: "personCategory",
  propNamePlural: "personCategories",
}
